import { EpStepContent, EpStepTextArea } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';

const DescriptionActionAfterIncidentInput = ({
  translations,
}: {
  translations: string[];
}) => {
  return (
    <EpStepContent.Label
      label={t(
        translations,
        'Describe the action taken immediately after the incident',
      )}
    >
      <EpStepTextArea
        required={false}
        errorMessage={t(translations, '* Required Fied')}
        maxLength={2000}
        registerId={'descriptionActionAfterIncident'}
        translations={translations}
      />
    </EpStepContent.Label>
  );
};

export default DescriptionActionAfterIncidentInput;
